import type { FormValues } from '../../promotions/types';

export type HistoryStatus = 'ativo' | 'encerrado' | 'rascunho' | 'agendado';

export interface HistoryRecord {
  id: string;
  briefingGroupId?: string;
  parentBriefingId?: string;
  templateId: string;
  templateName: string;
  templateColor: string;
  templateNumber: string;
  createdAt: string;
  updatedAt: string;
  status: HistoryStatus;
  author: string;
  values: FormValues;
}

export const HISTORY_RECORDS: HistoryRecord[] = [
  {
    id: 'h001',
    templateId: 't1',
    templateName: 'Rebaixa Simples',
    templateColor: '#1976d2',
    templateNumber: '01',
    createdAt: '2025-01-02T09:15:00',
    updatedAt: '2025-01-05T14:30:00',
    status: 'encerrado',
    author: 'Ana Souza',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-001', tipoMecanica: '1',
      nomePromo: 'Rebaixa Verão 2025', nomeExibicao: 'Desconto de Verão — até 15% OFF',
      descricao: 'Ganhe até 15% de desconto em produtos selecionados durante o verão. Válido até 31/03/2025.',
      descricaoInterna: 'Campanha de verão Q1 2025 — budget compartilhado com time de marketing.',
      tipoDesconto: '1', valorDesconto: '15', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '01/01/2025 00:00', fimVigencia: '31/03/2025 23:59',
      budgetAtrelado: '1', budgetValor: '50000',
      sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '150', valorMaximo: '999999', tipoItemIncluido: '3',
      itensIncluidos: ['Dove', 'Rexona', 'Axe'], eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h002',
    templateId: 't1',
    templateName: 'Rebaixa Simples',
    templateColor: '#1976d2',
    templateNumber: '01',
    createdAt: '2025-03-10T10:00:00',
    updatedAt: '2025-03-12T16:45:00',
    status: 'ativo',
    author: 'Carlos Lima',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-008', tipoMecanica: '1',
      nomePromo: 'Rebaixa Páscoa Dove', nomeExibicao: '20% OFF em Dove para a Páscoa',
      descricao: 'Aproveite 20% de desconto na linha Dove durante a Páscoa.',
      descricaoInterna: 'Ação Páscoa Q2 — linha Dove.',
      tipoDesconto: '1', valorDesconto: '20', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '2',
      inicioVigencia: '10/04/2025 00:00', fimVigencia: '21/04/2025 23:59',
      budgetAtrelado: '1', budgetValor: '25000',
      sellersIncluidos: ['Norte Sul - MT'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '80', valorMaximo: '999999', tipoItemIncluido: '3',
      itensIncluidos: ['Dove'], eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h003',
    templateId: 't2',
    templateName: 'Rebaixa Progressiva',
    templateColor: '#388e3c',
    templateNumber: '02',
    createdAt: '2025-04-01T08:20:00',
    updatedAt: '2025-04-03T11:10:00',
    status: 'ativo',
    author: 'Mariana Costa',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-012', tipoMecanica: '2',
      nomePromo: 'Rebaixa Progressiva Beleza', nomeExibicao: 'Compre mais, economize mais!',
      descricao: 'Desconto progressivo: 5% acima de R$100, 10% acima de R$250, 15% acima de R$500 em produtos de beleza.',
      descricaoInterna: 'Campanha progressiva Q2 2025.',
      numeroCard: '1', valorDesconto: '5', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '2',
      inicioVigencia: '01/04/2025 00:00', fimVigencia: '30/06/2025 23:59',
      budgetAtrelado: '1', budgetValor: '75000',
      sellersIncluidos: ['Norte Sul - MT', 'Karina - AC'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1'], criterioDesconto: '2',
      valorMinimo: '100', valorMaximo: '249', tipoItemIncluido: '3',
      itensIncluidos: ['Dove', 'TRESemmé', 'Seda'], eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h004',
    templateId: 't3',
    templateName: 'Compre e Ganhe',
    templateColor: '#f57c00',
    templateNumber: '03',
    createdAt: '2025-02-15T13:30:00',
    updatedAt: '2025-02-18T09:00:00',
    status: 'encerrado',
    author: 'João Ferreira',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-004', tipoMecanica: '3',
      nomePromo: 'Compre e Ganhe Shampoo', nomeExibicao: 'Leve 3 Pague 2 em Shampoos Selecionados',
      descricao: 'Compre 2 shampoos da família Seda e ganhe 1 condicionador grátis.',
      descricaoInterna: 'Ação A+B família cabelos Q2.',
      numeroCard: '1', valorDesconto: '100', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '01/03/2025 00:00', fimVigencia: '30/04/2025 23:59',
      budgetAtrelado: '2', budgetValor: '',
      sellersIncluidos: ['Norte Sul - MT'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'],
      tipoFamilia: '1', nomeFamilia: 'Shampoos Seda',
      industriaFamilia: 'Unilever', obsFamilia: '',
      skusFamilia: '7891150037250,7891150037250C12',
      qtdEANsDistintos: '2', qtdMinimaAtivacao: '2', qtdMaximaAtivacao: '',
    },
  },
  {
    id: 'h005',
    templateId: 't4a',
    templateName: 'Lista Sugerida — Original',
    templateColor: '#7b1fa2',
    templateNumber: '04A',
    createdAt: '2025-03-20T15:00:00',
    updatedAt: '2025-03-22T10:30:00',
    status: 'ativo',
    author: 'Fernanda Alves',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-009', tipoMecanica: '4', tipoLista: '1',
      nomePromo: 'Lista Mix Beleza Brasil Q2', nomeExibicao: 'Mix Beleza Brasil — Produtos com até 8% OFF',
      descricao: 'Lista curada com os melhores produtos de beleza com desconto exclusivo.',
      descricaoInterna: 'Lista sugerida Q2 — beleza e cuidados pessoais.',
      numeroCard: '1', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '01/04/2025 00:00', fimVigencia: '30/06/2025 23:59',
      budgetAtrelado: '2', budgetValor: '',
      sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'],
      posicaoLista: '1', secaoLista: 'Beleza e bem estar',
    },
  },
  {
    id: 'h006',
    templateId: 't4b',
    templateName: 'Lista Sugerida — Recompra',
    templateColor: '#0097a7',
    templateNumber: '04B',
    createdAt: '2025-04-25T11:00:00',
    updatedAt: '2025-04-26T14:20:00',
    status: 'agendado',
    author: 'Ricardo Gomes',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-015', tipoMecanica: '4', tipoLista: '2',
      idListaOriginal: '987654321',
      nomePromo: 'Recompra Lista Mix Beleza Brasil Q2', nomeExibicao: 'Recompra Mix Beleza — Seus favoritos com desconto!',
      descricao: 'Com base na sua última compra, selecionamos os melhores produtos com desconto exclusivo.',
      descricaoInterna: 'Recompra da lista Q2 beleza.',
      numeroCard: '1', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '01/05/2025 00:00', fimVigencia: '30/06/2025 23:59',
      budgetAtrelado: '2', budgetValor: '',
      sellersIncluidos: ['Norte Sul - MT'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'],
      posicaoLista: '2', secaoLista: 'Beleza e bem estar',
    },
  },
  {
    id: 'h007',
    templateId: 't5',
    templateName: 'Cupom Simples',
    templateColor: '#c62828',
    templateNumber: '05',
    createdAt: '2025-01-05T08:00:00',
    updatedAt: '2025-01-07T17:00:00',
    status: 'encerrado',
    author: 'Ana Souza',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-002', tipoMecanica: '5',
      nomePromo: 'VERAOOFF15', nomeExibicao: '15% OFF em Produtos Selecionados',
      descricao: 'Use o cupom VERAOOFF15 e ganhe 15% de desconto em produtos selecionados.',
      descricaoInterna: 'Cupom verão Q1 2025.',
      tipoDesconto: '1', valorDesconto: '15', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '2',
      inicioVigencia: '01/01/2025 00:00', fimVigencia: '31/03/2025 23:59',
      budgetAtrelado: '1', budgetValor: '30000',
      sellersIncluidos: ['Norte Sul - MT', 'Karina - AC', 'Recol - AC'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '100', valorMaximo: '999999',
      codigoCupom: 'VERAOOFF15', qtdCupons: '', usosPorCliente: '1',
      tipoItemIncluido: '7', itensIncluidos: ['Unilever'],
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h008',
    templateId: 't5',
    templateName: 'Cupom Simples',
    templateColor: '#c62828',
    templateNumber: '05',
    createdAt: '2025-04-10T09:00:00',
    updatedAt: '2025-04-10T09:00:00',
    status: 'rascunho',
    author: 'Carlos Lima',
    values: {
      tipoSolicitacao: '0', idIFC: 'n/a', tipoMecanica: '5',
      nomePromo: 'MAIO10', nomeExibicao: '10% OFF Dia das Mães',
      descricao: 'Presente especial para as mamães: use o cupom MAIO10 e ganhe 10% OFF.',
      descricaoInterna: 'Rascunho campanha Dia das Mães.',
      tipoDesconto: '1', valorDesconto: '10', industria: '1', multiPatrocinador: '0',
      patrocinadores: '', cumulativa: '',
      inicioVigencia: '', fimVigencia: '',
      budgetAtrelado: '1', budgetValor: '',
      sellersIncluidos: [], sellersExcecao: [],
      canais: [], tipoPedido: [],
      codigoCupom: 'MAIO10', qtdCupons: '', usosPorCliente: '1',
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h009',
    templateId: 't6',
    templateName: 'Cupom Progressivo',
    templateColor: '#455a64',
    templateNumber: '06',
    createdAt: '2025-04-02T10:30:00',
    updatedAt: '2025-04-04T16:00:00',
    status: 'ativo',
    author: 'Mariana Costa',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-013', tipoMecanica: '6',
      nomePromo: 'PROGRESSIVO25', nomeExibicao: 'Desconto Progressivo com Cupom',
      descricao: 'Use o cupom PROGRESSIVO25 e ganhe descontos crescentes dependendo do valor.',
      descricaoInterna: 'Cupom progressivo Q2 — teste de mecânica.',
      numeroCard: '1', valorDesconto: '5', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '2',
      inicioVigencia: '01/04/2025 00:00', fimVigencia: '30/06/2025 23:59',
      budgetAtrelado: '1', budgetValor: '45000',
      sellersIncluidos: ['Norte Sul - MT'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1'], criterioDesconto: '2',
      valorMinimo: '200', valorMaximo: '499',
      codigoCupom: 'PROGRESSIVO25', qtdCupons: '', usosPorCliente: '3',
      tipoItemIncluido: '3', itensIncluidos: ['Dove', 'Rexona'],
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h010',
    templateId: 't7',
    templateName: 'Cashback',
    templateColor: '#e65100',
    templateNumber: '07',
    createdAt: '2025-02-25T14:00:00',
    updatedAt: '2025-03-01T09:45:00',
    status: 'encerrado',
    author: 'João Ferreira',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-006', tipoMecanica: '7',
      nomePromo: 'CASHBACK250MARCO', nomeExibicao: 'Cashback de R$250 em Março',
      descricao: 'Compre produtos Unilever e ganhe R$250 de cashback no carrinho.',
      descricaoInterna: 'Cashback março 2025 — ação especial.',
      valorDesconto: '250', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '01/03/2025 00:00', fimVigencia: '31/03/2025 23:59',
      budgetAtrelado: '2', budgetValor: '',
      sellersIncluidos: [], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '1000', valorMaximo: '999999',
      codigoCupom: 'CASHBACK250MARCO', qtdCupons: '', usosPorCliente: '1',
      tipoItemIncluido: '7', itensIncluidos: ['Unilever'],
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h011',
    templateId: 't7',
    templateName: 'Cashback',
    templateColor: '#e65100',
    templateNumber: '07',
    createdAt: '2025-04-28T11:30:00',
    updatedAt: '2025-04-29T15:20:00',
    status: 'agendado',
    author: 'Fernanda Alves',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-018', tipoMecanica: '7',
      nomePromo: 'CASHBACK100MAIO', nomeExibicao: 'Cashback de R$100 em Maio',
      descricao: 'Compre R$500 em produtos e ganhe R$100 de cashback.',
      descricaoInterna: 'Cashback maio 2025.',
      valorDesconto: '100', industria: '1', multiPatrocinador: '0',
      patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '08/05/2025 00:00', fimVigencia: '31/05/2025 23:59',
      budgetAtrelado: '1', budgetValor: '80000',
      sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM', 'Karina - AC'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '500', valorMaximo: '999999',
      codigoCupom: 'CASHBACK100MAIO', qtdCupons: '', usosPorCliente: '1',
      tipoItemIncluido: '7', itensIncluidos: ['Unilever'],
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h012',
    templateId: 't8',
    templateName: 'Rebaixa / Cupom Geral',
    templateColor: '#37474f',
    templateNumber: '08',
    createdAt: '2025-04-01T09:00:00',
    updatedAt: '2025-04-03T14:00:00',
    status: 'ativo',
    author: 'Ricardo Gomes',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-010', tipoMecanica: '1',
      nomePromo: 'CIF10OFF', nomeExibicao: 'Compre Cif e Ganhe 10% OFF',
      descricao: 'Compre produtos Cif e ganhe 10% de desconto. Use o cupom CIF10OFF.',
      descricaoInterna: 'Ação Cif + cupom Q2 2025.',
      numeroCard: '0', tipoDesconto: '1', valorDesconto: '10', industria: '1',
      multiPatrocinador: '0', patrocinadores: 'Unilever 100%', cumulativa: '1',
      inicioVigencia: '01/04/2025 00:00', fimVigencia: '30/04/2025 23:59',
      budgetAtrelado: '1', budgetValor: '51520',
      sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '100', valorMaximo: '999999',
      cupom: '2', codigoCupom: 'CIF10OFF', qtdCupons: '', usosPorCliente: '1',
      marcasInclusao: ['Dove', 'Rexona'], marcasExclusao: [],
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h013',
    templateId: 't1',
    templateName: 'Rebaixa Simples',
    templateColor: '#1976d2',
    templateNumber: '01',
    createdAt: '2025-04-20T10:00:00',
    updatedAt: '2025-04-20T10:00:00',
    status: 'rascunho',
    author: 'Ana Souza',
    values: {
      tipoSolicitacao: '0', idIFC: 'n/a', tipoMecanica: '1',
      nomePromo: 'JUNINA2025', nomeExibicao: 'Promoção Junina 2025',
      descricao: '',
      descricaoInterna: 'Rascunho campanha junina.',
      tipoDesconto: '1', valorDesconto: '', industria: '1',
      multiPatrocinador: '0', patrocinadores: '',
      cumulativa: '', inicioVigencia: '', fimVigencia: '',
      budgetAtrelado: '', budgetValor: '',
      sellersIncluidos: [], sellersExcecao: [],
      canais: [], tipoPedido: [],
      eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
  {
    id: 'h014',
    templateId: 't2',
    templateName: 'Rebaixa Progressiva',
    templateColor: '#388e3c',
    templateNumber: '02',
    createdAt: '2025-05-01T08:00:00',
    updatedAt: '2025-05-02T11:00:00',
    status: 'agendado',
    author: 'Carlos Lima',
    values: {
      tipoSolicitacao: '0', idIFC: 'IFC-2025-020', tipoMecanica: '2',
      nomePromo: 'PROGRESSIVA_REXONA_MAIO', nomeExibicao: 'Faixas de Desconto Rexona — Maio',
      descricao: 'Compre mais produtos Rexona e obtenha desconto progressivo até 18% OFF.',
      descricaoInterna: 'Progressiva Rexona maio Q2.',
      numeroCard: '1', valorDesconto: '8', industria: '1',
      multiPatrocinador: '0', patrocinadores: 'Unilever 100%', cumulativa: '2',
      inicioVigencia: '08/05/2025 00:00', fimVigencia: '31/05/2025 23:59',
      budgetAtrelado: '1', budgetValor: '60000',
      sellersIncluidos: ['Norte Sul - MT', 'Karina - AC', 'Supergiro - AM'], sellersExcecao: [],
      canais: ['1', '2'], tipoPedido: ['1', '2'], criterioDesconto: '2',
      valorMinimo: '150', valorMaximo: '999999', tipoItemIncluido: '3',
      itensIncluidos: ['Rexona'], eansObrigatorios: [], skusObrigatorios: [], skuCombo: '0',
    },
  },
];

export const STATUS_LABELS: Record<HistoryStatus, string> = {
  ativo: 'Ativo',
  encerrado: 'Encerrado',
  rascunho: 'Rascunho',
  agendado: 'Agendado',
};

export const STATUS_COLORS: Record<HistoryStatus, 'success' | 'default' | 'warning' | 'info'> = {
  ativo: 'success',
  encerrado: 'default',
  rascunho: 'warning',
  agendado: 'info',
};
